module.exports = __webpack_public_path__ + "static/media/smile-icon.14c02094.svg";